export const checkIfAnimated = (animated: boolean) => {
    if (animated) {
        return 'active'
    }
    return ''
}